import React, { useState, forwardRef } from "react";

// Main OTP Component
export function InputOTP({ maxLength, children }) {
  const [values, setValues] = useState(Array(maxLength).fill(""));

  const handleChange = (index, value) => {
    if (value.length > 1) return; // Only allow single character
    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);
  };

  return (
    <div className="tw-flex tw-justify-center tw-gap-2">
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { values, handleChange })
      )}
    </div>
  );
}

// OTP Group (Wrapper)
export function InputOTPGroup({ children }) {
  return <div className="tw-flex tw-gap-3 tw-items-center">{children}</div>;
}

// OTP Separator (Centered Dash)
export function InputOTPSeparator() {
  return <span className="tw-text-lg tw-font-bold tw-text-center tw-mx-1">-</span>;
}

// OTP Slot (Each Input Box) — now forwards its ref!
export const InputOTPSlot = forwardRef(function InputOTPSlot(
  { index, values, handleChange },
  ref
) {
  return (
    <input
      ref={ref}                               // ← Attach the forwarded ref here
      type="text"
      maxLength={1}
      value={values[index] || ""}
      onChange={(e) => handleChange(index, e.target.value)}
      className="tw-border tw-p-3 tw-w-12 tw-text-center tw-rounded-lg tw-text-lg tw-font-medium tw-border-gray-300 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
      inputMode="numeric"
      pattern="\d*"
    />
  );
});
